import Vue from "vue";
import App from "./App.vue";
import store from "./Store/Store";
import router from './Routers/Routes';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/global.css';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

window.addEventListener("storage", (event) => {
  if (event.key === "token" && !event.newValue) {
    store.commit("LOGOUT");
    if (router.currentRoute.meta.requiresAuth) {
      router.push("/login");
      Vue.$toast.error("Your session has expired. Please log in again.", {
        timeout: 3000,
        position: "top-right",
        icon: "🔒"
      });
    }
  }
});

Vue.use(Toast, {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  newestOnTop: true,
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;
Vue.config.devtools = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
